import { getTicketParamsSchema } from "./get-ticket.schema";

export const patchTicketParamsSchema = getTicketParamsSchema;
